import { render, staticRenderFns } from "./Maquinas.vue?vue&type=template&id=812bc21e&scoped=true&"
import script from "./Maquinas.vue?vue&type=script&lang=js&"
export * from "./Maquinas.vue?vue&type=script&lang=js&"
import style0 from "./Maquinas.vue?vue&type=style&index=0&id=812bc21e&prod&lang=scss&scoped=true&"
import style1 from "./Maquinas.vue?vue&type=style&index=1&id=812bc21e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812bc21e",
  null
  
)

export default component.exports